<template>
  <div>
    <b-alert
      v-if="immediateActionRequirements.length < 1"
      show
      dismissible
      fade
      class="mt-1"
      variant="warning"
    >
      <div class="alert-body">
        Debe capturar al menos una accion inmediata
      </div>
    </b-alert>
    <div class="m-2">
      <!-- Table Top -->
      <b-row>
        <!-- Per Page -->
        <b-col
          cols="12"
          md="5"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label>{{ $t('Lists.Show') }}</label>
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            class="per-page-selector d-inline-block mx-50"
          />
          <label>{{ $t('Lists.Entries') }}</label>
        </b-col>
        <!-- Search -->
        <b-col
          cols="12"
          md="7"
        >
          <div class="d-flex align-items-center justify-content-end">
            <b-form-input
              v-model="searchQuery"
              class="d-inline-block mr-1"
              :placeholder="$t('Lists.Search')"
            />
            <b-button
              variant="primary"
              @click="onNewImmediateActionRequierement"
            >
              <span class="text-nowrap">Nueva accion inmediata</span>
            </b-button>
          </div>
        </b-col>
      </b-row>
    </div>
    <b-table
      ref="refImmediateActionRequirementTable"
      responsive
      :items="refetchImmediateActionRequirement"
      :fields="ImmediateActionRequirementFields"
      :sort-by.sync="sortBy"
      show-empty
      :empty-text="$t('Lists.NoMatchingRecordsFound')"
      :sort-desc.sync="isSortDirDesc"
    >
      <template
        #cell(actions)="data"
      >
        <b-dropdown
          variant="link"
          no-caret
          :right="$store.state.appConfig.isRTL"
        >
          <template #button-content>
            <feather-icon
              icon="MoreVerticalIcon"
              size="16"
              class="align-middle text-body"
            />
          </template>
          <b-dropdown-item @click="onSelectImmediateActionRequirement(data.item)">
            <feather-icon icon="EditIcon" />
            <span class="align-middle ml-50">{{ $t('Lists.Edit') }}</span>
          </b-dropdown-item>
          <b-dropdown-item @click="onDeleteImmediateActionRequirement(data.item)">
            <feather-icon icon="TrashIcon" />
            <span class="align-middle ml-50">{{ $t('Lists.Delete') }}</span>
          </b-dropdown-item>
        </b-dropdown>
      </template>
    </b-table>
    <div class="mx-2 mb-2">
      <b-row>
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted">{{ $t('Lists.Showing') }} {{ dataMeta.Showing }} {{ $t('Lists.To') }} {{ dataMeta.to }} {{ $t('Lists.Of') }} {{ dataMeta.of }} {{ $t('Lists.Entries') }}</span>
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalImmediateActionRequirements"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>
    <b-modal
      v-if="ImmediateActionRequirementSelected"
      id="modal-immediateActionRequirement"
      v-model="showEditImmediateActionRequirementModal"
      title="Nueva accion inmediata"
      size="xl"
    >
      <validation-observer
        ref="refImmediateActionRequirementRules"
        tag="form"
      >
        <b-row>
          <!-- Immediate Action input -->
          <b-col
            cols="12"
            md="4"
          >
            <validation-provider
              #default="validationContext"
              name="AccionInmediata"
              rules="required"
            >
              <b-form-group
                label="Accion inmediata"
              >
                <b-form-input
                  v-model="ImmediateActionRequirementSelected.descripcion"
                  :state="getValidationState(validationContext)"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <!-- cost applies check -->
          <b-col
            cols="12"
            md="4"
          >
            <b-form-group
              label="Aplica costo"
            >
              <b-form-checkbox
                v-model="ImmediateActionRequirementSelected.aplicaCosto"
              />
            </b-form-group>
          </b-col>
          <!-- cost input -->
          <b-col
            cols="12"
            md="4"
          >
            <b-form-group
              label="Costo"
            >
              <b-form-input
                v-model="ImmediateActionRequirementSelected.costo"
                :disabled="ImmediateActionRequirementSelected.aplicaCosto == false"
                type="number"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </validation-observer>
      <template #modal-footer>
        <div class="w-100">
          <b-button
            v-if="ImmediateActionRequirementSelected.requerimientoCorreccionInmediataId === 0 && !savingChanges"
            variant="primary"
            class="float-right"
            @click="validationImmediateActionRequirement(() => {
              onAddImmediateActionRequierement()
            })"
          >
            Guardar accion inmediata
          </b-button>
          <b-button
            v-if="ImmediateActionRequirementSelected.requerimientoCorreccionInmediataId > 0 && !savingChanges"
            variant="primary"
            class="float-right"
            @click="validationImmediateActionRequirement(() => {
              onEditImmediateActionRequirement()
            })"
          >
            Actualizar accion inmediata
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BPagination,
  // BModal,
  BDropdown,
  BDropdownItem,
  BFormGroup,
  BFormInvalidFeedback,
  BFormCheckbox,
  // BFormTextarea,
  // BImg,
  BAlert,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
// import FileUploader from '@/components/FileUploader.vue'
import { ref, watch, computed } from '@vue/composition-api'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import formValidation from '@core/comp-functions/forms/form-validation'
import { required } from '@validations'
import requirementService from '@/services/requirement.service'
import i18n from '@/libs/i18n'

export default {

  components: {
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BPagination,
    BFormGroup,
    // BModal,
    BDropdown,
    BDropdownItem,
    BFormInvalidFeedback,
    BFormCheckbox,
    // BFormTextarea,
    // BImg,
    BAlert,

    // FileUploader,

    vSelect,

    ValidationObserver,
    ValidationProvider,
  },
  props: {
    requerimientoId: {
      type: Number,
      required: true,
    },
    immediateActionCount: {
      type: Number,
      required: true,
    },
  },
  setup(props, { emit }) {
    /* Refs */
    const {
      fetchImmediateActionRequirement,
      createImmediateActionRequirement,
      deleteImmediateActionRequirement,
      updateImmediateActionRequirement,
    } = requirementService()
    const refImmediateActionRequirementTable = ref(null)
    const refImmediateActionRequirementRules = ref(null)

    /* Pagination */
    const perPageOptions = [10, 25, 50, 100]
    const perPage = ref(10)
    const currentPage = ref(1)
    /* Params */
    const searchQuery = ref('')
    const sortBy = ref('requerimientoCorreccionInmediataId')
    const isSortDirDesc = ref(false)
    /* Data */
    const totalImmediateActionRequirements = ref(0)
    const immediateActionRequirements = ref([])

    const blankImmediateActionRequirementData = {
      requerimientoCorreccionInmediataId: 0,
      requerimientoId: props.requerimientoId,
      descripcion: '',
      aplicaCosto: false,
      costo: null,
    }

    const ImmediateActionRequirementSelected = ref(JSON.parse(JSON.stringify(blankImmediateActionRequirementData)))
    const ImmediateActionRequirementFields = [
      {
        key: 'descripcion',
        label: 'Descripcion',
        sortable: false,
      },
      {
        key: 'costo',
        label: 'Costo',
        sortable: false,
      },
      {
        key: 'actions',
        label: i18n.t('Lists.Actions'),
        sortable: false,
      },
    ]
    const refetchImmediateActionRequirement = (ctx, callback) => {
      fetchImmediateActionRequirement(props.requerimientoId, {
        searchQuery: searchQuery.value,
        limit: perPage.value,
        offSet: currentPage.value === 1 ? 0 : (currentPage.value * perPage.value) - perPage.value,
        sort: `${sortBy.value} ${isSortDirDesc.value ? 'ASC' : 'DESC'}`,
      }, data => {
        immediateActionRequirements.value = data.correccionesInmediatas
        totalImmediateActionRequirements.value = data.total
        emit('update:immediate-action-count', totalImmediateActionRequirements.value)
        callback(immediateActionRequirements.value)
      })
    }

    const dataMeta = computed(() => {
      const localItemsCount = refImmediateActionRequirementTable.value ? refImmediateActionRequirementTable.value.localItems.length : 0
      return {
        from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
        to: perPage.value * (currentPage.value - 1) + localItemsCount,
        of: totalImmediateActionRequirements.value,
      }
    })

    const refreshData = () => {
      refImmediateActionRequirementTable.value.refresh()
    }
    watch([currentPage, perPage, searchQuery], () => {
      refreshData()
    })

    /* UI */
    const showEditImmediateActionRequirementModal = ref(false)
    // const showImageModal = ref(false)
    // const showQuantityConfirmationModal = ref(false)
    const savingChanges = ref(false)

    const onNewImmediateActionRequierement = () => {
      ImmediateActionRequirementSelected.value = JSON.parse(JSON.stringify(blankImmediateActionRequirementData))
      showEditImmediateActionRequirementModal.value = true
    }
    const onAddImmediateActionRequierement = () => {
      savingChanges.value = true
      createImmediateActionRequirement(ImmediateActionRequirementSelected.value, data => {
        ImmediateActionRequirementSelected.value = data
        savingChanges.value = false
        showEditImmediateActionRequirementModal.value = false
        refreshData()
      })
    }
    const onSelectImmediateActionRequirement = item => {
      ImmediateActionRequirementSelected.value = item
      showEditImmediateActionRequirementModal.value = true
    }

    const onEditImmediateActionRequirement = () => {
      savingChanges.value = true
      updateImmediateActionRequirement(ImmediateActionRequirementSelected.value)
        .then(() => {
          savingChanges.value = false
          showEditImmediateActionRequirementModal.value = false
          ImmediateActionRequirementSelected.value = null
          refreshData()
        })
    }
    const onDeleteImmediateActionRequirement = item => {
      deleteImmediateActionRequirement(item.requerimientoCorreccionInmediataId, () => {
        refreshData()
      })
    }
    const {
      getValidationState,
    } = formValidation()

    const validationImmediateActionRequirement = callback => {
      refImmediateActionRequirementRules.value.validate().then(success => {
        if (success) {
          callback()
        }
      })
    }
    return {
      refImmediateActionRequirementTable,
      refImmediateActionRequirementRules,

      perPageOptions,
      perPage,
      currentPage,
      searchQuery,
      sortBy,
      isSortDirDesc,
      ImmediateActionRequirementSelected,
      ImmediateActionRequirementFields,
      immediateActionRequirements,
      totalImmediateActionRequirements,

      dataMeta,

      refetchImmediateActionRequirement,

      required,
      getValidationState,

      showEditImmediateActionRequirementModal,

      savingChanges,

      onNewImmediateActionRequierement,
      onAddImmediateActionRequierement,
      onSelectImmediateActionRequirement,
      onEditImmediateActionRequirement,
      onDeleteImmediateActionRequirement,
      validationImmediateActionRequirement,
    }
  },
}
</script>

<style>

</style>
